<template>
  <footer class="w-full bg-white text-right p-4">
    Built by
    <a target="_blank" :href="url" class="underline">23 paskal</a>.
  </footer>
</template>

<script>
export default {
  name: "BottomBar",
  data() {
    return {
      url: process.env.VUE_APP_FRONTEND_URL,
    };
  },
};
</script>
